import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import Timesheets from './pages/Timesheets';
import Invoices from './pages/Invoices';
import InvoiceDetail from './pages/InvoiceDetail';
import InvoiceEdit from './pages/InvoiceEdit';
import InvoiceCreate from './pages/InvoiceCreate';
import Payments from './pages/Payments';
import Expenses from './pages/Expenses';
import Bank from './pages/Bank';
import Payroll from './pages/Payroll';
import PayslipDetail from './pages/PayslipDetail';
import Accounting from './pages/Accounting';
import TaxConfig from './pages/TaxConfig';
import Approvals from './pages/Approvals';
import Settings from './pages/Settings';
import CompanyConfiguration from './pages/CompanyConfiguration';
import UserManagement from './pages/UserManagement';
import TrainingAndObjectives from './pages/TrainingAndObjectives';
import Leads from './pages/Leads';
import Contributions from './pages/Contributions';
import { useAuth } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const App: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <CompanyProvider>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/clients" element={<Clients />} />
                    <Route path="/timesheets" element={<Timesheets />} />
                    <Route path="/approvals" element={<Approvals />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/company-configuration" element={<CompanyConfiguration />} />
                    <Route path="/user-management" element={<UserManagement />} />
                    <Route path="/invoices" element={<Invoices />} />
                    <Route path="/invoices/:id" element={<InvoiceDetail />} />
                    <Route path="/invoices/:id/edit" element={<InvoiceEdit />} />
                    <Route path="/invoices/create" element={<InvoiceCreate />} />
                    <Route path="/payments" element={<Payments />} />
                    <Route path="/expenses" element={<Expenses />} />
                    <Route path="/bank" element={<Bank />} />
                    <Route path="/payroll" element={<Payroll />} />
                    <Route path="/payroll/payslips/:id" element={<PayslipDetail />} />
                    <Route path="/contributions" element={<Contributions />} />
                    <Route path="/accounting" element={<Accounting />} />
                    <Route path="/tax-config" element={<TaxConfig />} />
                    <Route path="/training-objectives" element={<TrainingAndObjectives />} />
                    <Route path="/leads" element={<Leads />} />
                  </Routes>
                </Layout>
              </CompanyProvider>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Box>
  );
};

export default App;

